export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

// DOB comes from Postgres as "YYYY-MM-DD". Parse the components directly
// instead of new Date(...) — constructing a Date from "YYYY-MM-DD" treats
// it as UTC midnight and shifts by a day in negative-offset timezones.
export function formatDob(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[2]}/${m[3]}/${m[1]}`;
}

// Coarse "5 minutes ago" style label; falls back to the absolute date after 30 days.
export function formatRelative(iso: string, nowMs: number = Date.now()): string {
  const diffSec = Math.max(0, Math.round((nowMs - new Date(iso).getTime()) / 1000));
  if (diffSec < 60) return "just now";
  const units: Array<[string, number]> = [
    ["minute", 60],
    ["hour", 3600],
    ["day", 86400],
  ];
  let label = "minute";
  let value = 1;
  for (const [name, secs] of units) {
    if (diffSec >= secs) {
      label = name;
      value = Math.floor(diffSec / secs);
    }
  }
  if (label === "day" && value > 30) return formatDateTime(iso);
  return `${value} ${label}${value === 1 ? "" : "s"} ago`;
}
